var _slicedToArray = require("/home/ruben/dev/priv/whatsalyzer.com/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.whatsappChatParser = {}));
})(this, function (exports) {
  'use strict';

  /**
   * Checks that the number at a certain index of an array is greater than a
   * certain value.
   */
  function indexAboveValue(index, value) {
    return function (array) {
      return array[index] > value;
    };
  }
  /**
   * Returns `true` for a negative number, `false` otherwise.
   *
   * `0` and `-0` are considered positive.
   */
  function isNegative(number) {
    return number < 0;
  }
  /**
   * Takes an array of arrays and an index and groups the inner arrays by the
   * value at the index provided.
   * @see `utils.test.ts` for a better understanding of this function.
   */
  function groupArrayByValueAtIndex(array, index) {
    return Object.values(array.reduce(function (obj, item) {
      /*
       * Keys that are numbers (even strings containing a number) get sorted
       * when using `Object.values()`.
       * Adding a prefix avoids this issue.
       */
      var key = "_".concat(item[index]);
      if (!obj[key]) obj[key] = [];
      obj[key].push(item);
      return obj;
    }, {}));
  }

  /**
   * Takes an array of numeric dates and tries to understand if the days come
   * before the month or the other way around by checking if numbers go above
   * `12`.
   *
   * Output is `true` if days are first, `false` if they are second, or `null` if
   * it failed to understand the order.
   */
  function checkAbove12(numericDates) {
    var daysFirst = numericDates.some(indexAboveValue(0, 12));
    if (daysFirst) return true;
    var daysSecond = numericDates.some(indexAboveValue(1, 12));
    if (daysSecond) return false;
    return null;
  }
  /**
   * Takes an array of numeric dates and tries to understand if the days come
   * before the month or the other way around by checking if a set of numbers
   * during the same year decrease at some point.
   *
   * If it does it's probably the days since months can only increase in a given
   * year.
   *
   * Output is `true` if days are first, `false` if they are second, or `null` if
   * it failed to understand the order.
   */
  function checkDecreasing(numericDates) {
    var datesByYear = groupArrayByValueAtIndex(numericDates, 2);
    var results = datesByYear.map(function (dates) {
      var daysFirst = dates.slice(1).some(function (date, i) {
        var _dates$i = _slicedToArray(dates[i], 1),
          first1 = _dates$i[0];
        var _date = _slicedToArray(date, 1),
          first2 = _date[0];
        return isNegative(first2 - first1);
      });
      if (daysFirst) return true;
      var daysSecond = dates.slice(1).some(function (date, i) {
        var _dates$i2 = _slicedToArray(dates[i], 2),
          second1 = _dates$i2[1];
        var _date2 = _slicedToArray(date, 2),
          second2 = _date2[1];
        return isNegative(second2 - second1);
      });
      if (daysSecond) return false;
      return null;
    });
    var anyTrue = results.some(function (value) {
      return value === true;
    });
    if (anyTrue) return true;
    var anyFalse = results.some(function (value) {
      return value === false;
    });
    if (anyFalse) return false;
    return null;
  }
  /**
   * Takes an array of numeric dates and tries to understand if the days come
   * before the month or the other way around by looking at which number changes
   * more frequently.
   *
   * Output is `true` if days are first, `false` if they are second, or `null` if
   * it failed to understand the order.
   */
  function changeFrequencyAnalysis(numericDates) {
    var diffs = numericDates.slice(1).map(function (date, i) {
      return date.map(function (num, j) {
        return Math.abs(numericDates[i][j] - num);
      });
    });
    var _diffs$reduce = diffs.reduce(function (total, diff) {
        var _total = _slicedToArray(total, 2),
          first1 = _total[0],
          second1 = _total[1];
        var _diff = _slicedToArray(diff, 2),
          first2 = _diff[0],
          second2 = _diff[1];
        return [first1 + first2, second1 + second2];
      }, [0, 0]),
      _diffs$reduce2 = _slicedToArray(_diffs$reduce, 2),
      first = _diffs$reduce2[0],
      second = _diffs$reduce2[1];
    if (first > second) return true;
    if (first < second) return false;
    return null;
  }
  /**
   * Takes an array of numeric dates and tries to understand if the days come
   * before the month or the other way around by running the dates through various
   * checks.
   *
   * Output is `true` if days are first, `false` if they are second, or `null` if
   * it failed to understand the order.
   */
  function daysBeforeMonths(numericDates) {
    var firstCheck = checkAbove12(numericDates);
    if (firstCheck !== null) return firstCheck;
    var secondCheck = checkDecreasing(numericDates);
    if (secondCheck !== null) return secondCheck;
    return changeFrequencyAnalysis(numericDates);
  }
  /**
   * Takes `year`, `month` and `day` as strings and pads them to `4`, `2`, `2`
   * digits respectively.
   */
  function normalizeDate(year, month, day) {
    return [
    // 2 digit years are assumed to be in the 2000-2099 range
    year.padStart(4, '2000'), month.padStart(2, '0'), day.padStart(2, '0')];
  }
  /**
   * Pushes the longest number in a date to the end, if there is one. Necessary to
   * ensure the year is the last number.
   */
  function orderDateComponents(date) {
    var regexSplitDate = /[-/.] ?/;
    var _date$split = date.split(regexSplitDate),
      _date$split2 = _slicedToArray(_date$split, 3),
      a = _date$split2[0],
      b = _date$split2[1],
      c = _date$split2[2];
    var maxLength = Math.max(a.length, b.length, c.length);
    if (c.length === maxLength) return [a, b, c];
    if (b.length === maxLength) return [a, c, b];
    return [b, c, a];
  }
  var regexSplitTime = /[:.]/;
  /**
   * Converts time from 12 hour format to 24 hour format.
   *
   * Reference:
   * {@link https://stackoverflow.com/a/40197728/5303634}
   */
  function convertTime12to24(time, ampm) {
    // eslint-disable-next-line prefer-const
    var _time$split = time.split(regexSplitTime),
      _time$split2 = _slicedToArray(_time$split, 3),
      hours = _time$split2[0],
      minutes = _time$split2[1],
      seconds = _time$split2[2];
    if (hours === '12') hours = '00';
    if (ampm === 'PM') hours = String(parseInt(hours, 10) + 12);
    return "".concat(hours, ":").concat(minutes).concat(seconds ? ":".concat(seconds) : '');
  }
  /**
   * Normalizes a time string to have the following format: `hh:mm:ss`.
   */
  function normalizeTime(time) {
    var _time$split3 = time.split(regexSplitTime),
      _time$split4 = _slicedToArray(_time$split3, 3),
      hours = _time$split4[0],
      minutes = _time$split4[1],
      seconds = _time$split4[2];
    return "".concat(hours.padStart(2, '0'), ":").concat(minutes, ":").concat(seconds || '00');
  }
  /**
   * Normalizes `am` / `a.m.` / etc. to `AM` (uppercase, no other characters).
   */
  function normalizeAMPM(ampm) {
    return ampm.replace(/[^apm]/gi, '').toUpperCase();
  }
  var regexParser = /^(?:\u200E|\u200F)*\[?(\d{1,4}[-/.]\s?\d{1,4}[-/.]\s?\d{1,4})[,.]?\s\D*?(\d{1,2}[.:]\d{1,2}(?:[.:]\d{1,2})?)(?:\s([ap]\.?\s?m\.?))?\]?(?:\s-|:)?\s(.+?):\s([^]*)/i;
  var regexParserSystem = /^(?:\u200E|\u200F)*\[?(\d{1,4}[-/.]\s?\d{1,4}[-/.]\s?\d{1,4})[,.]?\s\D*?(\d{1,2}[.:]\d{1,2}(?:[.:]\d{1,2})?)(?:\s([ap]\.?\s?m\.?))?\]?(?:\s-|:)?\s([^]+)/i;
  var regexAttachment = /<.+:(.+)>|([A-Z\d-]+\.\w+)\s[(<].+[)>]/;
  /**
   * Takes an array of lines and detects the lines that are part of a previous
   * message (multiline messages) and merges them.
   *
   * It also labels messages without an author as system messages.
   */
  function makeArrayOfMessages(lines) {
    return lines.reduce(function (acc, line) {
      /*
       * If the line doesn't match the regex it's probably part of the previous
       * message or a "WhatsApp event"
       */
      if (!regexParser.test(line)) {
        /*
         * If it doesn't match the first regex but still matches the system regex
         * it should be considered a "WhatsApp event" so it gets labeled "system"
         */
        if (regexParserSystem.test(line)) {
          acc.push({
            system: true,
            msg: line
          });
        }
        // Else it's part of the previous message and it should be concatenated
        else if (typeof acc[acc.length - 1] !== 'undefined') {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          var prevMessage = acc.pop();
          acc.push({
            system: prevMessage.system,
            msg: "".concat(prevMessage.msg, "\n").concat(line)
          });
        }
      } else {
        acc.push({
          system: false,
          msg: line
        });
      }
      return acc;
    }, []);
  }
  /**
   * Parses a message extracting the attachment if it's present.
   */
  function parseMessageAttachment(message) {
    var attachmentMatch = message.match(regexAttachment);
    if (!attachmentMatch) return null;
    return {
      fileName: (attachmentMatch[1] || attachmentMatch[2]).trim()
    };
  }
  /**
   * Parses and array of raw messages into an array of structured objects.
   */
  function parseMessages(messages) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var daysFirst = options.daysFirst;
    var parseAttachments = options.parseAttachments; // Parse messages with regex
    var parsed = messages.map(function (obj) {
      var system = obj.system,
        msg = obj.msg; // If it's a system message another regex should be used to parse it
      if (system) {
        var _regexParserSystem$ex = regexParserSystem.exec(msg),
          _regexParserSystem$ex2 = _slicedToArray(_regexParserSystem$ex, 5),
          _date3 = _regexParserSystem$ex2[1],
          _time = _regexParserSystem$ex2[2],
          _ampm = _regexParserSystem$ex2[3],
          _message = _regexParserSystem$ex2[4];
        return {
          date: _date3,
          time: _time,
          ampm: _ampm || null,
          author: 'System',
          message: _message
        };
      }
      var _regexParser$exec = regexParser.exec(msg),
        _regexParser$exec2 = _slicedToArray(_regexParser$exec, 6),
        date = _regexParser$exec2[1],
        time = _regexParser$exec2[2],
        ampm = _regexParser$exec2[3],
        author = _regexParser$exec2[4],
        message = _regexParser$exec2[5];
      return {
        date: date,
        time: time,
        ampm: ampm || null,
        author: author,
        message: message
      };
    });
    // Understand date format if not supplied (do days come first?)
    if (typeof daysFirst !== 'boolean') {
      var numericDates = Array.from(new Set(parsed.map(function (_ref) {
        var date = _ref.date;
        return date;
      })), function (date) {
        return orderDateComponents(date).map(Number);
      });
      daysFirst = daysBeforeMonths(numericDates);
    }
    // Convert date and time in a `Date` object, return the final object
    return parsed.map(function (_ref2) {
      var date = _ref2.date,
        time = _ref2.time,
        ampm = _ref2.ampm,
        author = _ref2.author,
        message = _ref2.message;
      var day;
      var month;
      var year;
      var splitDate = orderDateComponents(date);
      if (daysFirst === false) {
        var _splitDate = _slicedToArray(splitDate, 3);
        month = _splitDate[0];
        day = _splitDate[1];
        year = _splitDate[2];
      } else {
        var _splitDate2 = _slicedToArray(splitDate, 3);
        day = _splitDate2[0];
        month = _splitDate2[1];
        year = _splitDate2[2];
      }
      var _normalizeDate = normalizeDate(year, month, day);
      var _normalizeDate2 = _slicedToArray(_normalizeDate, 3);
      year = _normalizeDate2[0];
      month = _normalizeDate2[1];
      day = _normalizeDate2[2];
      var _normalizeTime$split = normalizeTime(ampm ? convertTime12to24(time, normalizeAMPM(ampm)) : time).split(regexSplitTime),
        _normalizeTime$split2 = _slicedToArray(_normalizeTime$split, 3),
        hours = _normalizeTime$split2[0],
        minutes = _normalizeTime$split2[1],
        seconds = _normalizeTime$split2[2];
      var finalObject = {
        date: new Date(+year, +month - 1, +day, +hours, +minutes, +seconds),
        author: author,
        message: message
      };
      // Optionally parse attachments
      if (parseAttachments) {
        var attachment = parseMessageAttachment(message);
        if (attachment) finalObject.attachment = attachment;
      }
      return finalObject;
    });
  }
  var newlinesRegex = /(?:\r\n|\r|\n)/;
  /**
   * Parses a string containing a WhatsApp chat log.
   *
   * Returns a promise that will contain the parsed messages.
   *
   * @since 1.2.0
   */
  function parseString(string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      parseAttachments: false
    };
    return Promise.resolve(string).then(function (data) {
      return data.split(newlinesRegex);
    }).then(makeArrayOfMessages).then(function (messages) {
      return parseMessages(messages, options);
    });
  }
  /**
   * Parses a string containing a WhatsApp chat log.
   *
   * Returns an array of parsed messages.
   *
   * @since 3.2.0
   */
  function parseStringSync(string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      parseAttachments: false
    };
    var lines = string.split(newlinesRegex);
    return parseMessages(makeArrayOfMessages(lines), options);
  }
  exports.parseString = parseString;
  exports.parseStringSync = parseStringSync;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});